var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  CardManager: () => CardManager
});
var import_definition = __toModule(require("../definition"));
var import_yayoyakiValue = __toModule(require("../yayoyakiValue"));
var import_yayoyaki = __toModule(require("../yayoyaki"));
var import_cardFactory = __toModule(require("./cardFactory"));
var import_yayoyakiValidator = __toModule(require("../yayoyakiValidator"));
var import_utils = __toModule(require("../../utils"));
const DELETEABLE_EMPTY_CARD_TYPES = [import_definition.CardTypes.SUMMARY, import_definition.CardTypes.REAL_ESTATE];
class CardManager {
  constructor(samaData, samaForm, cardGroupForm, addScreenId, filter) {
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.cardGroupForm = cardGroupForm;
    this.addScreenId = addScreenId;
    this.filter = filter;
    this.getErrorChildrenMessages = () => {
      let messages = [];
      if (!this.cardGroupForm.childrenScreenId) {
        return messages;
      }
      const cardsId = this.samaForm.getScreenForm(this.cardGroupForm.childrenScreenId).cardsId;
      const yayoyakiChildrens = cardsId.flatMap((cardId) => this.samaForm.getCardForm(cardId).yayoyakiSiblingsId);
      cardsId.forEach((cardId) => {
        const cardLength = this.getCardLength(this.samaForm.getCardForm(cardId));
        for (let index = 0; index < cardLength; index++) {
          messages = [...messages, ...this.getErrorMessages(yayoyakiChildrens, index)];
        }
      });
      return (0, import_utils.removeDuplicates)(messages);
    };
    this.getErrorMessages = (yayoyakiSiblingsId, index) => {
      const messages = [];
      for (const yayoyakiId of yayoyakiSiblingsId) {
        const child = this.samaForm.getYayoyakiForm(yayoyakiId);
        const yayoyaki = new import_yayoyakiValue.YayoyakiValue(this.samaData, this.samaForm, child, index);
        if (!yayoyaki.isValid()) {
          messages.push({ id: yayoyaki.getId(), label: yayoyaki.getLabel() });
        }
      }
      return messages;
    };
    this.getFreelanceErrors = () => {
      if (this.getId() === "C00031" && this.addScreenId === "freelance_one_edit_1") {
        const freelanceYayos = ["Y01634", "Y01627", "Y01628"];
        return this.getErrorMessages(freelanceYayos);
      }
      return [];
    };
    this.cards = this.cardGroupForm.cardType === import_definition.CardTypes.GROUP ? this.initializeGroupCards() : this.initializeCards();
  }
  getCurrentCardLength() {
    return this.getCardLength(this.cardGroupForm);
  }
  getCardLength(cardGroup) {
    let length;
    for (const yayoyakiId of cardGroup.yayoyakiSiblingsId) {
      const yayoyakiForm = this.samaForm.getYayoyakiForm(yayoyakiId);
      if (import_yayoyakiValue.YayoyakiValue.isVisual(yayoyakiForm)) {
        continue;
      }
      const value = this.samaData.getValue(yayoyakiId);
      const yayoyakiLength = Array.isArray(value) ? value.length : value === void 0 ? 0 : 1;
      if (length !== void 0 && length !== yayoyakiLength) {
        throw new Error(`"${yayoyakiId}" length is invalid, current ${length} actual ${yayoyakiLength}`);
      }
      length = yayoyakiLength;
    }
    return length;
  }
  initializeCards() {
    const cards = [];
    const length = this.getCurrentCardLength();
    for (let i = 0; i < length; i += 1) {
      cards.push(import_cardFactory.CardFactory.createCard(this.cardGroupForm, this));
    }
    return cards;
  }
  initializeGroupCards() {
    if (this.cardGroupForm.header && this.getHeaders()) {
      return [import_cardFactory.CardFactory.createCard(this.cardGroupForm, this)];
    }
    return [];
  }
  deleteEmptyCards() {
    if (!this.isEmptyCardTypeDeleteable(this.cardGroupForm.cardType)) {
      return;
    }
    this.list(false).forEach((card) => {
      if (card.hasDefaultValue() && this.isDeleteable(card)) {
        this.delete(card);
      }
    });
  }
  getAdditionalIcons() {
    var _a, _b;
    const additionalIconExpression = (_a = this.cardGroupForm.additionalIcon) == null ? void 0 : _a.condition;
    const additionalIconsShow = import_yayoyakiValidator.YayoyakiValidator.evaluateExpression(this.samaData.getUserData(), additionalIconExpression);
    if (Array.isArray(additionalIconsShow)) {
      return additionalIconsShow == null ? void 0 : additionalIconsShow.map((show) => {
        var _a2;
        if (show) {
          return (_a2 = this.cardGroupForm.additionalIcon) == null ? void 0 : _a2.url;
        }
      });
    }
    if (additionalIconsShow) {
      return (_b = this.cardGroupForm.additionalIcon) == null ? void 0 : _b.url;
    }
  }
  getAdditionalIcon(card) {
    var _a;
    const index = this.getValidCardIndex(card);
    return (_a = this.getAdditionalIcons()) == null ? void 0 : _a[index];
  }
  getHeaders() {
    const headerExpression = this.cardGroupForm.header;
    return import_yayoyakiValidator.YayoyakiValidator.evaluateExpression(this.samaData.getUserData(), headerExpression);
  }
  getHeader(card) {
    var _a;
    const index = this.getValidCardIndex(card);
    return (_a = this.getHeaders()) == null ? void 0 : _a[index];
  }
  getIcon() {
    return this.cardGroupForm.icon;
  }
  getSubheaders() {
    if (!this.cardGroupForm.subheaderYayoyakisId) {
      return;
    } else if (Array.isArray(this.cardGroupForm.subheaderYayoyakisId)) {
      const yayosConcated = [];
      for (const yayoyakiId of this.cardGroupForm.subheaderYayoyakisId) {
        const yayoyakiForm = this.samaForm.getYayoyakiForm(yayoyakiId);
        if (!yayoyakiForm) {
          throw new Error(`Card "${this.cardGroupForm.cardId}" has subheader with yayoyaki "${yayoyakiId}" but not found in yayoyakiSiblingsId`);
        }
        const values = import_yayoyaki.Yayoyaki.getRenderValues(this.samaData, this.samaForm, yayoyakiForm);
        for (const [i, value] of values.entries()) {
          if (!yayosConcated[i]) {
            yayosConcated[i] = "";
          }
          if (value) {
            yayosConcated[i] += yayosConcated[i] ? ` ${value}` : value;
          }
        }
      }
      return yayosConcated;
    }
  }
  getSubheader(card) {
    var _a;
    const index = this.getValidCardIndex(card);
    return (_a = this.getSubheaders()) == null ? void 0 : _a[index];
  }
  isFilter() {
    var _a;
    return !!((_a = this.filter) == null ? void 0 : _a.yayoyakiParentId);
  }
  add(navigationIndex) {
    if (this.cardGroupForm.readOnly) {
      throw new Error(`Cannot add in "${this.cardGroupForm.cardId}" is read only`);
    }
    if (!this.addScreenId) {
      throw new Error(`Cannot add in "${this.cardGroupForm.cardId}" addScreenId is undefined`);
    }
    const yayoyakisFormArray = this.samaForm.getYayoyakisArrayForm(this.cardGroupForm.yayoyakiSiblingsId);
    const newIndex = this.samaData.addValues(yayoyakisFormArray);
    if (newIndex !== this.cards.length) {
      throw new Error(`Index returned by addValues is invalid`);
    }
    if (this.filter) {
      const value = this.samaData.getValueMatrix(this.filter.yayoyakiParentId, navigationIndex);
      this.samaData.setValue(this.filter.yayoyakiCurrentId, value, newIndex);
    }
    this.cards.push(import_cardFactory.CardFactory.createCard(this.cardGroupForm, this));
    return { id: this.addScreenId, index: newIndex };
  }
  deleteAllYayoyakis(yayoyakisFormArray) {
    const length = this.getCurrentCardLength();
    for (let index = 0; index < length; index++) {
      this.samaData.deleteValues(yayoyakisFormArray, this.getCurrentCardLength() - 1);
    }
  }
  delete(card) {
    if (this.cardGroupForm.readOnly) {
      throw new Error(`Cannot delete in "${this.cardGroupForm.cardId}" is read only`);
    }
    const index = this.getValidCardIndex(card);
    const yayoyakisFormArray = this.samaForm.getYayoyakisArrayForm(this.cardGroupForm.yayoyakiSiblingsId);
    if (this.cardGroupForm.cardType === import_definition.CardTypes.GROUP) {
      this.deleteAllYayoyakis(yayoyakisFormArray);
    } else {
      this.samaData.deleteValues(yayoyakisFormArray, index);
    }
    if (this.isReviewable()) {
      this.samaData.deleteUserCardCacheValue(this.getId(), card.getIndex());
    }
    this.cards.splice(index, 1);
  }
  isDeleteable(card) {
    return this.getValidCardIndex(card) >= 0 && !this.cardGroupForm.readOnly;
  }
  deleteAll() {
    Array.from(this.cards).forEach((card) => this.delete(card));
  }
  edit(card) {
    const index = this.getValidCardIndex(card);
    return { id: this.cardGroupForm.editScreenId, index };
  }
  list(filter = true) {
    if (filter) {
      if (this.isFilter()) {
        const value = this.samaData.getValueMatrix(this.filter.yayoyakiParentId, this.filter.index);
        return this.cards.filter((_card, index) => {
          return this.samaData.getValueMatrix(this.filter.yayoyakiCurrentId, index) === value;
        });
      }
      return this.cards.filter((card) => !card.isFiltered());
    }
    return this.cards;
  }
  getYayoyakisSiblings(index) {
    return this.cardGroupForm.yayoyakiSiblingsId.map((yayoyakiId) => {
      const yayoyakiForm = this.samaForm.getYayoyakiForm(yayoyakiId);
      return new import_yayoyakiValue.YayoyakiValue(this.samaData, this.samaForm, yayoyakiForm, index);
    });
  }
  getYayoyakisSiblingsId() {
    return this.cardGroupForm.yayoyakiSiblingsId;
  }
  getYayoyakis(index) {
    const yayoyakis = this.cardGroupForm.yayoyakisId.map((yayoyakiId) => {
      const yayoyakiForm = this.samaForm.getYayoyakiForm(yayoyakiId);
      return new import_yayoyakiValue.YayoyakiValue(this.samaData, this.samaForm, yayoyakiForm, index);
    });
    return yayoyakis;
  }
  validate(card) {
    const index = this.getValidCardIndex(card);
    const messages = (0, import_utils.removeDuplicates)([
      ...this.getErrorMessages(this.cardGroupForm.yayoyakiSiblingsId, index),
      ...this.getErrorChildrenMessages(),
      ...this.getFreelanceErrors()
    ]);
    return { isValid: messages.length === 0, messages };
  }
  getCardIndex(card) {
    return this.cards.indexOf(card);
  }
  get(index) {
    return this.cards[index];
  }
  isEditEnabled(index) {
    if (this.cardGroupForm.editScreenRequirement) {
      return !!import_yayoyakiValidator.YayoyakiValidator.validateRequirementsSafe(this.samaData.getUserData(), this.cardGroupForm.editScreenRequirement, index);
    }
    return true;
  }
  getId() {
    return this.cardGroupForm.id;
  }
  isReviewable() {
    var _a;
    return !!((_a = this.cardGroupForm) == null ? void 0 : _a.reviewable);
  }
  getUserCardsCache() {
    return this.samaData.getUserCardsCache().getValues();
  }
  getValidCardIndex(card) {
    const index = this.cards.indexOf(card);
    if (index === -1) {
      throw new Error(`Given card does not exist in this card summary`);
    }
    return index;
  }
  isEmptyCardTypeDeleteable(cardType) {
    return DELETEABLE_EMPTY_CARD_TYPES.includes(cardType);
  }
  getCardGroupRenderForm() {
    return this.cardGroupForm;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardManager
});
